import transformObjKeysToUpperCase from './transformObjKeysToUpperCase'

const textObjFn = props => {
  const { contact, vastuser, preferences, account } = props

  const propKeys = Object.keys(props || {})
  const defaultContactValues = propKeys.reduce((acc, el) => {
    if (el?.slice?.(0, 8) === 'Contact.') {
      acc[el?.slice?.(8)] = props?.[el]
    }
    return acc
  }, {})

  const textObj = {
    Contact: {
      ...defaultContactValues,
      ...(contact || {}),
      phone: contact?.phones?.[0]?.number || props?.['Contact.phone'] || '',
      email: contact?.email?.[0]?.address || props?.['Contact.email'] || '',
    },
    AssignedUser: {
      user_name: vastuser?.user_name || props?.['AssignedUser.user_name'] || '',
      first_name:
        vastuser?.first_name || props?.['AssignedUser.first_name'] || '',
      last_name: vastuser?.last_name || props?.['AssignedUser.last_name'] || '',
      email: vastuser?.email || props?.['AssignedUser.email'] || '',
      phone_number:
        props?.assignedNumber ||
        props?.['AssignedUser.phone_number'] ||
        vastuser?.phone_number ||
        '',
    },
    Account: {
      id: account?.id || props?.['Account.id'] || '',
      name: account?.name || props?.['Account.name'] || '',
      business_name:
        account?.business_name || props?.['Account.business_name'] || '',
      mailing:
        `${account?.mailing?.address_line_1 || ''} ${
          account?.mailing?.address_line_2 || ''
        } ${account?.mailing?.city || ''}, ${
          account?.mailing?.state_province || ''
        } ${account?.mailing?.zip || ''} ${account?.mailing?.country || ''}` ||
        props?.['Account.mailing'] ||
        '',
    },
    AccountPreference: Object.keys(preferences || {}).reduce((acc, el) => {
      acc[el] = preferences?.[el] || props?.[`AccountPreference.${el}` || '']
      return acc
    }, {}),
  }

  return { ...textObj, ...transformObjKeysToUpperCase(textObj) }
}

export default textObjFn
